import { initialState } from "../initialState";
import { SET_ERROR } from "../actionTypes";

const errorReducer = (state = initialState.error, action) => {
    return action.type === SET_ERROR ? action.payload : state;
};

export default errorReducer;
